// extracted by mini-css-extract-plugin
export default {"text":"SelectWords_text__nqVns"};